import React from 'react';
import Icon from '@ant-design/icons';
import StringifyWidgetProcessor, {
	StringifyWidgetState,
} from '@kemu-io/kemu-core/widgets/stringify/index.js';

import { WidgetState, WidgetPortContext } from '@kemu-io/kemu-core/types';
import classNames from 'classnames';
import GateIcon from '../../gateIcon/gateIcon';
import {
	GetPortsInformationFunction,
	GateUI,
	GateUIProps,
} from '../index.ts';
import { PortLocation } from '../../../types/canvas_t';
import styles from './stringify.module.css';
import { ReactComponent as StringifyIcon } from './icon.svg';

const StringifyWidget = (props: GateUIProps): React.JSX.Element => {

	return (
		<div className={classNames(styles.GateBody, {
			[styles.WidgetDisabled]: props.info.disabled,
		})}>
			<Icon component={StringifyIcon}/>
		</div>
	);
};

/** Icon to be added to the bar */
const GateBarIcon = (): React.JSX.Element => {
	return (
		<GateIcon icon={<Icon component={StringifyIcon} />}/>
	);
};

const getPortsInformation: GetPortsInformationFunction = (state: WidgetState<StringifyWidgetState>, widgetInfo) => {
	const portContext: WidgetPortContext = {
		recipePoolId: widgetInfo.recipePoolId,
		recipeType: widgetInfo.recipeType,
		thingRecipeId: widgetInfo.thingRecipeId,
		widgetId: widgetInfo.id,
	};
	const outputNames = StringifyWidgetProcessor.getOutputNames(state, portContext);
	const inputNames = StringifyWidgetProcessor.getInputNames(state, portContext);

	const positions: Record<string, PortLocation> = {
		'text': [1, 0.3, 1, 0],
		'error': [1, 0.7, 1, 0]
	};

	return {
		inputs: [{
			position: 'Left',
			name: inputNames[0].name,
			type: inputNames[0].type,
		}],

		outputs: outputNames.map(output => ({
			name: output.name,
			type: output.type,
			position: positions[output.name],
			label: output.label
		})),
	};
};

export default {
	getPortsInformation,
	BarIcon: GateBarIcon,
	Element: StringifyWidget,
	hasTitle: false,
	getGatesBarTitle: (intl) => intl.formatMessage({ id: 'LogicMapper.Widgets.Stringify.Title' }),
} as GateUI;
